module.exports = __webpack_public_path__ + "assets/img/21df4664ff8ff567154d263c8f702083.png";